import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { QuotationMasterCloneAndCreateRequestDTO, QuotationMasterCreateRequestDTO, QuotationMasterDeleteRequestDTO, QuotationMasterDTO, QuotationMasterGetMaxVersionNoRequestDTO, QuotationMasterGetMaxVersionNoResponseDTO, QuotationMasterList, QuotationMasterReadByTenantIdRequestDTO, QuotationMasterReadByIdRequestDTO, QuotationMasterSearchByQuotationNumberRequestDTO, QuotationMasterUpdateRequestDTO, QuotationMasterUpdateStatusRequestDTO, QuotationMasterCreateIndentFromQuotationRequestDTO } from './quotation.interface';
import { Observable } from 'rxjs';
import { QuotationMaster_CloneAndCreate, QuotationMaster_create, QuotationMaster_delete, QuotationMaster_GetMaxVersionNo, QuotationMaster_readAll, QuotationMaster_readByCompanyId, QuotationMaster_readById, QuotationMaster_SearchByQuotationNumber, QuotationMaster_update, QuotationOtherDetail_create, QuotationOtherDetail_delete, QuotationOtherDetail_readById, QuotationOtherDetail_readByQuotationId, QuotationOtherDetail_update, QuotationMaster_updateStatus, QuotationMaster_createIndentFromQuotation } from 'src/app/GlobalVariables';
import { QuotationOtherDetailCreateRequestDTO, QuotationOtherDetailDeleteRequestDTO, QuotationOtherDetailDTO, QuotationOtherDetailList, QuotationOtherDetailReadByIdRequestDTO, QuotationOtherDetailReadByQuotationIdRequestDTO, QuotationOtherDetailUpdateRequestDTO } from './quotationOtherdetail.interface';

@Injectable({
  providedIn: 'root'
})
export class QuotationService {

  constructor() { }

  http = inject(HttpClient);

  QuotationMaster_create(data: QuotationMasterCreateRequestDTO): Observable<QuotationMasterDTO> {
    return this.http.post<QuotationMasterDTO>(QuotationMaster_create, data);
  }

  QuotationMaster_update(data: QuotationMasterUpdateRequestDTO): Observable<QuotationMasterDTO>{
    return this.http.post<QuotationMasterDTO>(QuotationMaster_update, data);
  }

  QuotationMaster_Delete(data: QuotationMasterDeleteRequestDTO): Observable<void>{
    return this.http.post<void>(QuotationMaster_delete, data);
  }

  QuotationMaster_ReadById(data: QuotationMasterReadByIdRequestDTO): Observable<QuotationMasterDTO>{
    return this.http.post<QuotationMasterDTO>(QuotationMaster_readById, data);
  }

  QuotationMaster_ReadAll(): Observable<QuotationMasterList>{
     return this.http.get<QuotationMasterList>(QuotationMaster_readAll);
  }

  QuotationMaster_ReadByCompanyId(data: QuotationMasterReadByTenantIdRequestDTO) : Observable<QuotationMasterList>{
    return this.http.post<QuotationMasterList>(QuotationMaster_readByCompanyId, data);
  }

  QuotationMaster_CloneAndCreate(data:QuotationMasterCloneAndCreateRequestDTO):Observable<QuotationMasterDTO>{
    return this.http.post<QuotationMasterDTO>(QuotationMaster_CloneAndCreate,data)
  }

  QuotationMaster_SearchByQuotationNumber(data:QuotationMasterSearchByQuotationNumberRequestDTO):Observable<QuotationMasterList>{
    return this.http.post<QuotationMasterList>(QuotationMaster_SearchByQuotationNumber,data)
  }

  QuotationMaster_GetMaxVersionNo(data: QuotationMasterGetMaxVersionNoRequestDTO): Observable<QuotationMasterGetMaxVersionNoResponseDTO> {
    return this.http.post<QuotationMasterGetMaxVersionNoResponseDTO>(QuotationMaster_GetMaxVersionNo, data);
  }

  QuotationOtherDetail_create(data: QuotationOtherDetailCreateRequestDTO): Observable<QuotationOtherDetailDTO> {
    return this.http.post<QuotationOtherDetailDTO>(QuotationOtherDetail_create, data);
  }
  QuotationOtherDetail_update(data: QuotationOtherDetailUpdateRequestDTO): Observable<QuotationOtherDetailDTO> {
    return this.http.post<QuotationOtherDetailDTO>(QuotationOtherDetail_update, data);
  }
  quotationOtherDetail_delete(data:QuotationOtherDetailDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(QuotationOtherDetail_delete, data);
  }
  quotationOtherDetail_readByQuotationId(data:QuotationOtherDetailReadByQuotationIdRequestDTO): Observable<QuotationOtherDetailList> {
    return this.http.post<QuotationOtherDetailList>(QuotationOtherDetail_readByQuotationId, data);
  }
  QuotationOtherDetail_readById(data:QuotationOtherDetailReadByIdRequestDTO): Observable<QuotationOtherDetailDTO> {
    return this.http.post<QuotationOtherDetailDTO>(QuotationOtherDetail_readById, data);
  }
  QuotationMaster_updateStatus(data: QuotationMasterUpdateStatusRequestDTO): Observable<QuotationMasterDTO> {
    return this.http.post<QuotationMasterDTO>(QuotationMaster_updateStatus, data);
  }
  QuotationMaster_createIndentFromQuotation(data: QuotationMasterCreateIndentFromQuotationRequestDTO): Observable<any> {
    return this.http.post<any>(QuotationMaster_createIndentFromQuotation, data);
  }

}
